import variables from 'common/config/variables';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import { hexToRGB } from 'common/utils/helpers';

GlobalStyle.inject`
.category-horizontal-list {
    display: flex;
    flex-direction: row;
    padding: ${getScalablePixel(8)}px 0;

    .category-horizontal-list-item-separator {
        color: ${variables.color_grey_30};
        font-size: ${getScalablePixel(46)}px;
        margin: 0 ${getScalablePixel(8)}px;
    }

    .main-category-horizontal-list-item {
        background: transparent !important;
        padding: ${getScalablePixel(8)}px !important;
        .title {
            color: ${variables.color_grey_10} !important;
            font-size: ${getScalablePixel(24)}px !important;
            font-weight: 700 !important;
            text-transform: uppercase;
        }
    }

    .main-category-horizontal-list-item, .category-horizontal-list-item {
        background: ${hexToRGB(variables.color_grey_50, 0.4)};
        margin: 0 ${getScalablePixel(8)}px;
        padding: ${getScalablePixel(12)}px ${getScalablePixel(16)}px;
        border-radius: ${getScalablePixel(4)}px;

        &.focused {
            background: ${variables.color_grey_50} !important;
            box-shadow: 0 0 0 ${getScalablePixel(1)}px ${variables.color_grey_30};

            .title {
                color: ${variables.color_grey_10};
            }
        }

        .title {
            font-size: ${getScalablePixel(20)}px;
            color: ${variables.color_grey_50};
            font-weight: 400;
        }
    }
}
`;
